<template>
    <standard-frame :sub-title="displayItem.title" :sub-content="displayItem.content"/>
</template>

<script>
  import StandardFrame from './StandardFrame'

  export default {
    name: 'ContactUs',
    components: {StandardFrame},
    data() {
      return {
        displayItem:{
          title:'联系我们',
          content:`<p>联系电话：0571-89986918</p>
                                               <p>公司地址：杭州市西湖区留下街道杨家排楼311号宇弘智谷302室</p>`
        }
      }
    }
  }
</script>
